import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-50edd1b1")

_pushScopeId("data-v-50edd1b1")
const _hoisted_1 = { class: "flex flex-col h-full min-h-0" }
const _hoisted_2 = { class: "py-3 px-6 flex flex-row items-center justify-between shrink-0" }
const _hoisted_3 = { class: "font-semibold text-black-lp-100 text-xl" }
const _hoisted_4 = { class: "w-full py-2 px-4 flex-1 min-h-0 bg-gray-lp-1200" }
const _hoisted_5 = { class: "bg-white w-full h-full rounded-xl p-4 flex flex-col min-h-0" }
const _hoisted_6 = { class: "flex flex-row items-center justify-start gap-4 border-b border-gray-lp-400 w-full mb-4 shrink-0" }
const _hoisted_7 = { class: "flex-1 min-h-0 overflow-y-auto" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("cargoV2.create.index.title")), 1),
      _createVNode(_component_lp_button, {
        title: _ctx.$t('cargoV2.create.index.manualBookingBtn'),
        outline: "",
        textColor: "red-lp-100",
        color: "red-lp-100",
        onClick: _ctx.onCreateBookingManual
      }, null, 8, ["title", "onClick"])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: tab.path,
              to: tab.path
            }, {
              default: _withId(({ href, navigate, isExactActive }) => [
                _createVNode("a", {
                  href: href,
                  class: ['rtc-tab', { 'rtc-tab-active': isExactActive }],
                  onClick: _withModifiers(($event: any) => (_ctx.onTabClick(tab, navigate)), ["prevent"])
                }, _toDisplayString(_ctx.$t(tab.titleKey)), 11, ["href", "onClick"])
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128))
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_router_view)
        ])
      ])
    ])
  ]))
})